import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import TextInputField from 'components/layout/forms/TextInputField';
import getTargetName from 'services/forms/getTargetName';
import getTargetValue from 'services/forms/getTargetValue';
import translations from 'services/translations/translations';

import actionTypes from '../types/actionTypes';

const AddConnectionByDelta = ({
  setActionType,
}: {
  setActionType: (actionType: string) => void;
}): JSX.Element | null => {
  const [delta, setDelta] = useState({ deltaX: '500', deltaY: '0' });

  const { t } = useTranslation([translations.common]);

  const addConnection = () => {
    window.AddConnectionByDelta(delta);
    setActionType(actionTypes.addWall);
  };

  const handleDelta = (e: any) => {
    setDelta({
      ...delta,
      [getTargetName(e)]: getTargetValue(e),
    });
  };

  return (
    <>
      <TextInputField
        id="deltaX"
        label={t(`${translations.common}:Delta X`)}
        onChange={handleDelta}
        value={delta.deltaX}
        name="deltaX"
        required
      />
      <TextInputField
        id="deltaY"
        label={t(`${translations.common}:Delta Y`)}
        onChange={handleDelta}
        value={delta.deltaY}
        name="deltaY"
        required
      />

      <PrimaryButton onClick={addConnection}>
        {t(`${translations.common}:Add`).toLocaleUpperCase()}
      </PrimaryButton>
    </>
  );
};

export default AddConnectionByDelta;
